module.exports = __webpack_public_path__ + "static/media/food.765847ed.jpg";